import { ChainId, Token } from '@nominex/nomiswap-sdk'

const TWT_CDN_BASE_URL = 'https://assets-cdn.trustwallet.com/blockchains'
const NMX_CDN_BASE_URL = 'https://nominex.io/static/filters:format(webp)/s.nominex.io/images/icons'

const TWT_CDN_CHAIN_MAP = {
  [ChainId.BSC]: 'smartchain',
  [ChainId.ETHEREUM]: 'ethereum',
  [ChainId.MATIC]: 'polygon',
}

export const getTokenLogoURL = (token: Token, source: 'nominex' | 'twt' = 'twt'): string | null => {
  if (!token) {
    return null
  }

  return {
    twt: `${TWT_CDN_BASE_URL}/${TWT_CDN_CHAIN_MAP[token.chainId]}/assets/${token.address}/logo.png`,
    nominex: `${NMX_CDN_BASE_URL}/currency-new/${token.symbol?.toLowerCase()}.png`,
  }[source]
}

export const getNetworkLogoURL = (chainId: ChainId) => `${NMX_CDN_BASE_URL}/networks/${chainId}.png`
